import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-2" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { class: "p-field mt-2" }
const _hoisted_5 = {
  class: "p-field-label",
  for: "buildingname"
}
const _hoisted_6 = {
  for: "buildingname",
  class: "fs-13 label-error"
}
const _hoisted_7 = {
  key: 0,
  class: "p-field"
}
const _hoisted_8 = {
  class: "p-field-label",
  for: "apartmentnumber"
}
const _hoisted_9 = {
  for: "apartmentnumber",
  class: "fs-13 label-error"
}
const _hoisted_10 = { class: "p-field mb-4" }
const _hoisted_11 = { class: "d-flex align-items-start" }
const _hoisted_12 = { class: "p-field-label" }
const _hoisted_13 = { class: "p-field mb-3" }
const _hoisted_14 = { class: "d-flex align-items-start" }
const _hoisted_15 = { class: "p-field-label" }
const _hoisted_16 = {
  key: 0,
  class: "hr mt-4"
}
const _hoisted_17 = { class: "p-field" }
const _hoisted_18 = { class: "d-flex align-items-start" }
const _hoisted_19 = {
  style: {"width":"30%"},
  class: "p-field-label pl-2 ml-auto"
}
const _hoisted_20 = { class: "p-field" }
const _hoisted_21 = {
  key: 0,
  class: "hr mt-4"
}
const _hoisted_22 = { class: "dialog-custom__footer" }
const _hoisted_23 = {
  key: 0,
  class: "form-custom mr-auto"
}
const _hoisted_24 = { class: "p-field-label" }
const _hoisted_25 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_26 = { class: "label-error fs-13" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_NumberButtons = _resolveComponent("NumberButtons")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          style: [{"width":"450px"}, { height: _ctx.brfaStep === 0 ? '355px' : '60vh'}]
        }, [
          (_ctx.brfaStep === 0)
            ? (_openBlock(), _createBlock(_component_ElScrollbar, {
                key: 0,
                class: "dialog-scroll"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("label", _hoisted_5, _toDisplayString(_ctx.inputLabel), 1),
                    _createVNode(_component_InputText, {
                      id: "buildingname",
                      type: "text",
                      class: ["w-100", { 'input-error': !_ctx.isValidName }],
                      modelValue: _ctx.building.name,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => (_ctx.building.name = $event)),
                        _ctx.verifyValidityOfName
                      ]
                    }, null, 8, ["modelValue", "class", "onUpdate:modelValue"]),
                    _createVNode("label", _hoisted_6, _toDisplayString(_ctx.invalidNameReason), 1)
                  ]),
                  (!_ctx.isEdit && !_ctx.currentEntrancePlant.hasRiserInterface)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("AppResourceEP.Apartments")), 1),
                        _createVNode(_component_InputNumber, {
                          id: "apartmentnumber",
                          class: ["w-50", { 'input-error': !_ctx.validApartmentNumber }],
                          fluid: "",
                          min: "1",
                          max: _ctx.availableApartments,
                          modelValue: _ctx.building.apartmentsCount,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => (_ctx.building.apartmentsCount = $event)),
                            _ctx.checkValidApartmentNumber
                          ]
                        }, null, 8, ["max", "modelValue", "class", "onUpdate:modelValue"]),
                        _createVNode("label", _hoisted_9, _toDisplayString(_ctx.invalidNumberReason), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.brfaStep === 1)
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("span", _hoisted_11, [
                    _createVNode("label", null, _toDisplayString(`${_ctx.$t("AppResourceEP.Risers")} ${
                                        _ctx.building.name
                                    }`), 1),
                    _createVNode(_component_NumberButtons, {
                      class: "ml-auto",
                      modelValue: _ctx.risersCount,
                      minValue: 1,
                      onIncrement: _ctx.addRiser,
                      onDecrement: _ctx.removeRiser
                    }, null, 8, ["modelValue", "onIncrement", "onDecrement"])
                  ])
                ]),
                _createVNode(_component_ElScrollbar, {
                  class: "dialog-scroll",
                  style: {"height":"calc(100% - (25px + 1.5rem))"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rfaConfig.risers, (riser, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index,
                        class: ["p-field", {'mb-3': _ctx.isLast(index)}]
                      }, [
                        _createVNode("label", _hoisted_12, _toDisplayString(_ctx.riserName(index + 1)), 1),
                        _createVNode(_component_InputText, {
                          type: "text",
                          class: "w-50",
                          modelValue: riser.name,
                          "onUpdate:modelValue": ($event: any) => (riser.name = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ], 2))
                    }), 128))
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.brfaStep === 2)
            ? (_openBlock(), _createBlock(_component_ElScrollbar, {
                key: 2,
                class: "dialog-scroll"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rfaConfig.risers, (riser, riserIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      key: riserIndex,
                      class: "mb-3"
                    }, [
                      _createVNode("div", _hoisted_13, [
                        _createVNode("span", _hoisted_14, [
                          _createVNode("label", null, _toDisplayString(`${_ctx.$t("AppResourceEP.Floors")} ${riser.name}`), 1),
                          _createVNode(_component_NumberButtons, {
                            class: "ml-auto",
                            modelValue: _ctx.floorsCount(riser),
                            minValue: 1,
                            maxValue: 200,
                            onIncrement: ($event: any) => (_ctx.addFloor(riser)),
                            onDecrement: ($event: any) => (_ctx.removeFloor(riser))
                          }, null, 8, ["modelValue", "onIncrement", "onDecrement"])
                        ])
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(riser.floors, (floor, floorIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          key: floorIndex,
                          class: "p-field mt-3"
                        }, [
                          _createVNode("label", _hoisted_15, _toDisplayString(_ctx.floorName(floorIndex + 1)), 1),
                          _createVNode(_component_InputText, {
                            type: "text",
                            class: "w-50",
                            modelValue: floor.name,
                            "onUpdate:modelValue": ($event: any) => (floor.name = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]))
                      }), 128)),
                      (!_ctx.isLast(riserIndex))
                        ? (_openBlock(), _createBlock("hr", _hoisted_16))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.brfaStep === 3)
            ? (_openBlock(), _createBlock(_component_ElScrollbar, {
                key: 3,
                class: "dialog-scroll"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rfaConfig.risers, (riser, riserIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      key: riserIndex,
                      class: "mb-3"
                    }, [
                      _createVNode("div", _hoisted_17, [
                        _createVNode("h6", null, _toDisplayString(riser.name), 1),
                        _createVNode("span", _hoisted_18, [
                          _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("AppResourceEP.Apartments")), 1)
                        ])
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(riser.floors, (floor, floorIndex) => {
                        return (_openBlock(), _createBlock("span", {
                          key: floorIndex,
                          class: "d-flex align-items-center"
                        }, [
                          _createVNode("div", _hoisted_20, [
                            _createVNode("label", null, _toDisplayString(_ctx.floorLabel(floor, floorIndex + 1)), 1)
                          ]),
                          _createVNode(_component_Dropdown, {
                            style: {"width":"30%"},
                            class: "apartment__count ml-auto",
                            options: _ctx.apartmentCountValues,
                            optionLabel: "label",
                            optionValue: "value",
                            modelValue: floor.numberOfApartments,
                            "onUpdate:modelValue": ($event: any) => (floor.numberOfApartments = $event)
                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                        ]))
                      }), 128)),
                      (!_ctx.isLast(riserIndex))
                        ? (_openBlock(), _createBlock("hr", _hoisted_21))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 4)
      ]),
      _createVNode("footer", _hoisted_22, [
        (_ctx.brfaStep === 3 && !_ctx.allApartmentsAssigned())
          ? (_openBlock(), _createBlock("span", _hoisted_23, [
              _createVNode("span", _hoisted_24, [
                _createVNode("label", null, _toDisplayString(_ctx.mismatchedApartmentsErrorText[0]), 1),
                _hoisted_25,
                _createVNode("label", _hoisted_26, _toDisplayString(_ctx.mismatchedApartmentsErrorText[1]), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          label: _ctx.secondaryButtonLabel,
          onClick: _ctx.handleSecondaryButtonAction
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Button, {
          class: "p-button-rounded p-button-raised p-button--m",
          label: _ctx.buttonSubmitLabel,
          disabled: _ctx.saveButtonDisabled,
          onClick: _ctx.handleButtonSubmitAction
        }, null, 8, ["label", "disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}